import { render, staticRenderFns } from "./substitute-teacher-invitation.view.vue?vue&type=template&id=1cc6d188&scoped=true&"
import script from "./substitute-teacher-invitation.view.ts?vue&type=script&lang=ts&"
export * from "./substitute-teacher-invitation.view.ts?vue&type=script&lang=ts&"
import style0 from "./substitute-teacher-invitation.view.scss?vue&type=style&index=0&id=1cc6d188&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cc6d188",
  null
  
)

export default component.exports